import { render, staticRenderFns } from "./BoardingHierarchyDetails.vue?vue&type=template&id=cd2cd4f6&scoped=true"
import script from "./BoardingHierarchyDetails.vue?vue&type=script&lang=js"
export * from "./BoardingHierarchyDetails.vue?vue&type=script&lang=js"
import style0 from "./BoardingHierarchyDetails.vue?vue&type=style&index=0&id=cd2cd4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2cd4f6",
  null
  
)

export default component.exports